import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
}), 'Sort');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Sort.js
// module id = 6313
// module chunks = 2